import TableCell from '../../../components/tableCell';
import { Table, Space, Tooltip, Row, Col } from 'antd';
import { ReactComponent as ActionsIcon } from '../../../assets/icons/more_dots.svg';
import {
  getFullDateTimeWithSeconds,
  getDisplayCompanySizeLabel,
} from 'utils/helpers';

export const fundingAdminColumns = (onMoreClick) => [
  {
    title: 'Αρ. Αίτησης',
    dataIndex: 'id',
    key: 'id',
    render: (text, record) => {
      return (
        <TableCell id={`id-${record.id}`} text={text} />
      );
    },
    sorter: {
      compare: (a, b) => a.id - b.id,
    },
    width: 110,
  },
  {
    title: 'ΑΦΜ Επιχείρησης',
    dataIndex: 'companyVat',
    key: 'companyVat',
    render: (text, record) => {
      return (
        <TableCell id={`companyVat-cell-${record.companyVat}`} text={text} />
      );
    },
    sorter: {
      compare: (a, b) => a.companyVat - b.companyVat,
    },
    width: 140,
  },
  {
    title: 'Επωνυμία Επιχείρησης',
    dataIndex: 'companyName',
    key: 'companyName',
    render: (text, record) => {
      return (
        <TableCell id={`companyName-cell-${record.companyName}`} text={text} />
      );
    },
    sorter: {
      compare: (a, b) =>
        (a.companyName || '')
          .toLowerCase()
          .localeCompare((b.companyName || '').toLowerCase(), 'el'),
    },
    width: 150,
  },
  {
    title: 'Όνομα',
    dataIndex: 'firstName',
    key: 'firstName',
    render: (text, record) => {
      return (
        <TableCell id={`firstName-cell-${record.firstName}`} text={text} />
      );
    },
    sorter: {
      compare: (a, b) =>
        (a.firstName || '')
          .toLowerCase()
          .localeCompare((b.firstName || '').toLowerCase(), 'el'),
    },
    width: 140,
  },
  {
    title: 'Επώνυμο',
    dataIndex: 'lastName',
    key: 'lastName',
    render: (text, record) => {
      return <TableCell id={`lastName-cell-${record.lastName}`} text={text} />;
    },
    sorter: {
      compare: (a, b) =>
        (a.lastName || '')
          .toLowerCase()
          .localeCompare((b.lastName || '').toLowerCase(), 'el'),
    },
    width: 140,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (text, record) => {
      return <TableCell id={`email-cell-${record.email}`} text={text} />;
    },
    sorter: {
      compare: (a, b) =>
        (a.email || '')
          .toLowerCase()
          .localeCompare((b.email || '').toLowerCase(), 'el'),
    },
    width: 150,
  },
  {
    title: 'Τηλέφωνο',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    render: (text, record) => {
      return (
        <TableCell id={`phoneNumber-cell-${record.phoneNumber}`} text={text} />
      );
    },
    sorter: {
      compare: (a, b) => a.phoneNumber - b.phoneNumber,
    },
    width: 130,
  },
  // {
  //   title: 'Μέγεθος Επιχείρησης',
  //   dataIndex: 'companySize',
  //   key: 'companySize',
  //   render: (text, record) => {
  //     return (
  //       <TableCell
  //         id={`companySize-cell-${record.companySize}`}
  //         text={getDisplayCompanySizeLabel(text)}
  //       />
  //     );
  //   },
  //   sorter: {
  //     compare: (a, b) =>
  //       (a.companySize || '')
  //         .toLowerCase()
  //         .localeCompare((b.companySize || '').toLowerCase(), 'el'),
  //   },
  //   width: 120,
  // },
  {
    title: 'Ημ. Υποβολής',
    dataIndex: 'creationDate',
    key: 'creationDate',
    render: (text, record) => {
      return (
        <TableCell
          id={`creationDate-cell-${record.businessKey}`}
          text={getFullDateTimeWithSeconds(text)}
        />
      );
    },
    sorter: {
      compare: (a, b) => {
        if (a.creationDate && b.creationDate) {
          return new Date(a.creationDate) - new Date(b.creationDate);
        } else if (!a.creationDate && b.creationDate) {
          return -1;
        } else if (a.creationDate && !b.creationDate) {
          return 1;
        } else {
          return 0;
        }
      },
    },
    width: 140,
  },
  {
    title: '',
    fixed: 'right',
    key: 'action',
    align: 'center',
    width: 80,
    render: (text, record) => {
      return (
        <Space
          id={`action-cell-${record.id}`}
          align="end"
        >
          <Tooltip title="Actions">
            <div className='action-icon-wrapper'
              onClick={(e) => onMoreClick(record.id, record, e)}
            >
            <ActionsIcon
              aria-describedby={record.id}
              style={{
                pointerEvents: 'none',
              }}
            />
            </div>
          </Tooltip>
        </Space>
      );
    },
  },
];
